import { BoxProps, TextNewProps } from '@jfs/ui-new'

export const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}
export const styles = {
  Default: {
    outerContainer: {
      flex: 1,
      top: 0,
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 16,
      backgroundColor: 'ERROR',
      borderRadius: 8,
      flexDirection: 'column',
      zIndex: 4,
    } as BoxProps,
    container: {
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 16,
    } as BoxProps,
    textContainer: {} as BoxProps,
    title: {
      fontSize: 16,
      fontWeight: '600',
      color: 'DARK_BLUE',
    } as TextNewProps,
    subTitle: {
      fontSize: 14,
      fontWeight: '500',
      color: 'BLACK',
    } as TextNewProps,
    buttonContainer: { alignSelf: 'flex-end', flex: 1 } as BoxProps,
    closeIconContainer: {} as BoxProps,
  },

  Error: {
    outerContainer: {
      flex: 1,
      top: 0,
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 16,
      backgroundColor: 'ERROR',
      borderRadius: 8,
      flexDirection: 'column',
      zIndex: 4,
    } as BoxProps,
    container: {
      flex: 1,
      top: 0,
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      zIndex: 4,
    } as BoxProps,
    textContainer: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      zIndex: 4,
      marginHorizontal: 16,
      marginTop: -2,
    } as BoxProps,
    title: {
      fontSize: 16,
      fontWeight: '600',
      color: 'WHITE',
    } as TextNewProps,
    subTitle: {
      fontSize: 14,
      fontWeight: '500',
      color: 'WHITE',
    } as TextNewProps,
    buttonContainer: {
      flex: 1,
    } as BoxProps,
    closeIconContainer: { justifyContent: 'flex-end' } as BoxProps,
  },
  Confirm: {
    outerContainer: {
      flex: 1,
      top: 0,
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 16,
      backgroundColor: 'ERROR',
      borderRadius: 8,
      flexDirection: 'column',
      zIndex: 4,
    } as BoxProps,
    container: {
      w: 408,
      h: 162,
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 16,
      borderRadius: 8,
    } as BoxProps,
    textContainer: {
      alignSelf: 'flex-start',
    } as BoxProps,
    title: {
      fontSize: 16,
      fontWeight: 'MEDIUM',
      color: 'BLACK_21',
    } as TextNewProps,
    subTitle: {
      fontSize: 12,
      fontWeight: 'MEDIUM',
      color: 'BLACK_75',
    } as TextNewProps,
    buttonContainer: { alignSelf: 'flex-end', flexDirection: 'row', h: 30, marginTop: 16 } as BoxProps,
    closeIconContainer: {} as BoxProps,
  },
}
